import { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { TextInput } from 'jl-design-system/components/text-input/TextInput';

export class TextField extends PureComponent {
  render() {
    const {
      id,
      value,
      onBlur,
      onChange,
      name,
      className,
      labelText = '',
      supportingText,
      errorText,
    } = this.props;

    return (
      <TextInput
        id={id}
        type="text"
        value={value}
        className={classnames(className) || 'sessioncamexclude'}
        onChange={onChange}
        onBlur={onBlur}
        name={name}
        labelText={labelText}
        supportingText={supportingText}
        errorText={errorText}
      />
    );
  }
}

TextField.propTypes = {
  id: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  className: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  labelText: PropTypes.string,
  supportingText: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  errorText: PropTypes.string,

  onChange: PropTypes.func.isRequired,
  onBlur: PropTypes.func.isRequired,
};

TextField.defaultProps = {
  className: '',
  labelText: '',
  supportingText: undefined,
  errorText: '',
};
